import { TableCell, TableRow, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useApiFeedback } from "../../../../app/useApiFeedback";
import MessageResponse from "../../../../common/feedback/messageResponse";
import CircularLoader from "../../../../common/loaders/circularLoader";
import CustomTable from "../../../../common/tables/table";
import { AssessmentAuditsDto } from "../../models";
import { selectAdmin } from "../../adminSlice";
import { getAssessmentAuditsThunk } from "../../thunks";

const columns = [
  "#",
  "Name",
  "Surname",
  "Identity Number",
  "Application Status From",
  "Application Status To",
  "Change Reason",
  "Change Date",
  "Application Stage",
];

export default function AllAssessmentsAudits() {
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [page, setPage] = useState<number>(0);
  const [data, setData] = useState<AssessmentAuditsDto[]>([]);
  const adminSelect = useAppSelector(selectAdmin);
  const dispatch = useAppDispatch();
  const { feedback, handleApiResponse } = useApiFeedback();

  useEffect(() => {
    if (adminSelect.assessmentAuditsState.assessmentAudits) {
      setData(adminSelect.assessmentAuditsState.assessmentAudits);
    }
  }, [adminSelect.assessmentAuditsState.assessmentAudits]);

  useEffect(() => {
    dispatch(getAssessmentAuditsThunk()).then((resp: any) => {
      handleApiResponse(resp, false);
    });
  }, []);

  const createTableRows = () => {
    return (
      <>
        {data
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((record: AssessmentAuditsDto, key: React.Key) => {
            return (
              <TableRow key={key}>
                <TableCell>{parseInt(key.toString()) + 1}</TableCell>
                <TableCell>{record.firstName}</TableCell>
                <TableCell>{record.surname}</TableCell>
                <TableCell>{record.identityNumber}</TableCell>
                <TableCell>{record.applicationStatusFrom}</TableCell>
                <TableCell>{record.applicationStatusTo}</TableCell>
                <TableCell>{record.changeReason}</TableCell>
                <TableCell>
                  {moment(record.changeDateTime).format("YYYY/MM/DD")}
                </TableCell>
                <TableCell>{record.applicationStage}</TableCell>
              </TableRow>
            );
          })}
      </>
    );
  };
  return (
    <>
      <MessageResponse feedback={feedback} />
      <Typography variant="h5" gutterBottom>Assessment Audits</Typography>
      <CircularLoader status={adminSelect.assessmentAuditsState.status} />
      {adminSelect.assessmentAuditsState.status === "idle" && (
        <CustomTable
          columns={columns}
          data={data}
          rowsPerPage={rowsPerPage}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          rows={() => createTableRows()}
          page={page}
        />
      )}
      
    </>
  );
}
